import React, { useState } from 'react';
import styles from './localizacoes_wendril_instrutor78_.module.scss';
import { useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const locations = [
    {
        name: "Academia Vitta Fitness",
        address: "R. Fábio Junqueira Franco, 1013 - Exposicao, Barretos - SP, 14783-040",
        coordinates: "https://maps.app.goo.gl/qKHpdaDZdQgwGg1S6",
        horarios: [
            {
                dia: "Segunda", horarios: [
                    "18:30hrs às 19:30hrs"
                ]
            },
            {
                dia: "Quarta", horarios: [
                    "18:30hrs às 19:30hrs"
                ]
            }
        ]
    },
    {
        name: "Grêmio Literário e Recreativo de Barretos - Sede Esportiva",
        address: "Av. Vinte e Um, 1295 - Centro, Barretos - SP, 14780-310",
        coordinates: "https://maps.app.goo.gl/ugF9t4yytdMscc2k7",
        horarios: [
            {
                dia: "Segunda", horarios: [
                    "19:30hrs às 20:30hrs"
                ]
            },
            {
                dia: "Terça", horarios: [
                    "18:30hrs às 19:30hrs"
                ]
            },
            {
                dia: "Quinta", horarios: [
                    "18:30hrs às 19:30hrs"
                ]
            }
        ]
    },
    {
        name: "SkyFit Academias - Unidade Barretos",
        address: "Av. dos Maçons, 177 - Jardim Ramos, Barretos - SP, 14783-167",
        coordinates: "https://maps.app.goo.gl/w8kHT1FrdrUUzzb98",
        horarios: [
            {
                dia: "Segunda", horarios: [
                    "06:00hrs às 07:00hrs",
                    "16:00hrs às 17:00hrs",
                    "20:30hrs às 21:30hrs"
                ]
            },
            {
                dia: "Terça", horarios: [
                    "06:00hrs às 07h:00hrs",
                    "19:30hrs às 21:30hrs"
                ]
            },
            {
                dia: "Quarta", horarios: [
                    "06:00hrs às 07:00hrs",
                    "16:00hrs às 17:00hrs",
                    "19:30hrs às 21:30hrs"
                ]
            },
            {
                dia: "Quinta", horarios: [
                    "06:00hrs às 07:00hrs",
                    "19:30hrs às 21:30hrs"
                ]
            },
            {
                dia: "Sexta", horarios: [
                    "06:00hrs às 07:00hrs",
                    "16:00hrs às 17:00hrs",
                    "19:30hrs às 21:30hrs"
                ]
            }
        ]
    },
    {
        name: "Sindicato dos Empregados do Comercio de Barretos",
        address: "Av. 13, 635 (16X18) - Centro, Barretos - SP, 14780-270",
        coordinates: "https://maps.app.goo.gl/oVZF5xJG1HyW8nx26",
        horarios: []
    }
];
const Localizacoes_wendril_instrutor78_: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState<any>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openModal = (location: any) => {
        setSelectedLocation(location);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedLocation(null);
    };
    return (
        <div className={styles.localizacoes_wendril_instrutor78_}>
            <div className="mb-4 d-flex align-items-center gap-2">
                <Link to="/wendril_instrutor78_" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">LOCALIZAÇÕES</h1>
            </div>
            {locations.map((location, index) => (
                <div key={index} className={styles.locationCard}>
                    <h5>{location.name}</h5>
                    <p className={styles.locationAddress}>{location.address}</p>
                    <div className={styles.buttonsContainer}>
                        <a href={location.coordinates} target="_blank" rel="noopener noreferrer" className={styles.mapButton}>
                            Ver no mapa
                        </a>
                        <button onClick={() => openModal(location)} className={styles.mapButton}>
                            Ver horários
                        </button>
                    </div>
                </div>
            ))}
            {modalOpen && selectedLocation && (
                <div className={styles.modalOverlay} onClick={closeModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <h5 className="mb-3">{selectedLocation.name}</h5>
                        {selectedLocation.horarios.length > 0 ? (
                            <div className={styles.scheduleContainer}>
                                {selectedLocation.horarios.map((item: any, idx: number) => (
                                    <div key={idx} className={styles.scheduleItem}>
                                        <span className={styles.day}>{item.dia}</span>
                                        <div className={styles.timeList}>
                                            {item.horarios && item.horarios.map((hora: string, index: number) => (
                                                <p key={index} className={styles.time}>{hora}</p>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>Horários em breve!</p>
                        )}

                        <button onClick={closeModal} className={styles.mapButton}>Fechar</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Localizacoes_wendril_instrutor78_;